import React from "react";
import Typewriter from "typewriter-effect";
import { HiOutlineArrowDownTray, HiArrowRight } from "react-icons/hi2";
import { FiMapPin } from "react-icons/fi";
import { SITE, SOCIALS, ROLES } from "../../data/portfolio";
import SocialIcon from "../ui/SocialIcon";
import pdf from "../../Assets/MUHAMMAD_ABDULLAH_SHAKOOR.pdf";

function Home() {
  return (
    <section
      id="home"
      className="relative flex min-h-[100svh] items-center pt-28 pb-20"
    >
      <div className="container-page grid grid-cols-1 items-center gap-12 lg:grid-cols-[1.1fr_minmax(0,0.9fr)]">
        {/* Left */}
        <div className="flex min-w-0 flex-col items-start gap-6">
          <span
            className="chip animate-fade-in max-w-full font-mono text-[0.7rem] uppercase tracking-[0.16em] text-accent-soft"
            style={{ animationDelay: "60ms" }}
          >
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400 shadow-[0_0_8px_2px_rgba(52,211,153,0.6)]" />
            Open to full-time &amp; freelance work
          </span>

          <h1
            className="animate-fade-up w-full font-display text-[2rem] font-bold leading-[1.1] sm:text-5xl lg:text-6xl"
            style={{ animationDelay: "120ms" }}
          >
            Hi, I&apos;m <span className="text-gradient">Abdullah</span>.
            <br />
            <span className="text-ink-muted">I engineer </span>
            <span className="text-ink">the full stack.</span>
          </h1>

          <div
            className="animate-fade-up flex w-full min-w-0 items-center gap-2 overflow-hidden font-mono text-base text-accent-soft sm:text-xl"
            style={{ animationDelay: "200ms" }}
          >
            <span className="shrink-0 text-ink-faint">{"<"}</span>
            <Typewriter
              options={{
                strings: ROLES,
                autoStart: true,
                loop: true,
                delay: 55,
                deleteSpeed: 30,
              }}
            />
            <span className="shrink-0 text-ink-faint">{"/>"}</span>
          </div>

          <p
            className="animate-fade-up w-full max-w-xl text-base leading-relaxed text-ink-muted sm:text-lg"
            style={{ animationDelay: "260ms" }}
          >
            {SITE.tagline} I build across the stack — from web applications and
            AI-powered systems to data pipelines, automation, and connected
            devices.
          </p>

          <div
            className="animate-fade-up flex flex-wrap items-center gap-3"
            style={{ animationDelay: "320ms" }}
          >
            <a href="#projects" className="btn btn-primary">
              View my work <HiArrowRight />
            </a>
            <a
              href={pdf}
              target="_blank"
              rel="noreferrer"
              className="btn btn-ghost"
            >
              <HiOutlineArrowDownTray /> Download CV
            </a>
          </div>

          <div
            className="animate-fade-up flex items-center gap-5 pt-2"
            style={{ animationDelay: "380ms" }}
          >
            <div className="flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="grid h-10 w-10 place-items-center rounded-lg border border-line bg-white/5 text-lg text-ink-muted transition-all hover:-translate-y-0.5 hover:border-accent/50 hover:text-accent-soft"
                >
                  <SocialIcon name={s.icon} />
                </a>
              ))}
            </div>
            <span className="hidden items-center gap-1.5 text-sm text-ink-faint sm:flex">
              <FiMapPin /> {SITE.location}
            </span>
          </div>
        </div>

        {/* Right — code card */}
        <div
          className="animate-fade-up relative mx-auto w-full min-w-0 max-w-md lg:mx-0"
          style={{ animationDelay: "260ms" }}
        >
          <div className="absolute -inset-4 -z-10 rounded-3xl bg-accent/20 blur-3xl" />
          <div className="card-surface overflow-hidden shadow-card">
            <div className="flex items-center gap-2 border-b border-line bg-white/[0.03] px-4 py-3">
              <span className="h-3 w-3 rounded-full bg-red-400/80" />
              <span className="h-3 w-3 rounded-full bg-yellow-400/80" />
              <span className="h-3 w-3 rounded-full bg-green-400/80" />
              <span className="ml-2 font-mono text-xs text-ink-faint">
                developer.js
              </span>
            </div>
            <pre className="min-w-0 overflow-x-auto p-4 font-mono text-[0.72rem] leading-relaxed text-ink-muted sm:p-5 sm:text-[0.82rem]">
              <code>
                <span className="text-accent-soft">const</span> developer ={" "}
                {"{"}
                {"\n"} name:{" "}
                <span className="text-emerald-300">'Abdullah Shakoor'</span>,
                {"\n"} role:{" "}
                <span className="text-emerald-300">'Full Stack Developer'</span>
                ,{"\n"} builds: [<span className="text-emerald-300">'Web'</span>
                , <span className="text-emerald-300">'AI'</span>,{" "}
                <span className="text-emerald-300">'IoT'</span>],
                {"\n"} stack: [<span className="text-emerald-300">'React'</span>
                , <span className="text-emerald-300">'Node.js'</span>,{" "}
                <span className="text-emerald-300">'Python'</span>],
                {"\n"} shipsProducts:{" "}
                <span className="text-accent-soft">true</span>,{"\n"} learning:{" "}
                <span className="text-accent-soft">'always'</span>,{"\n"}
                {"}"};
              </code>
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
